/**
 * @generated SignedSource<<c21b1e632ad166fa311f4bec08ddd8b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Main_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AuthGuard_data" | "CurrentUserProvider_data" | "MainToolbar_data">;
  readonly " $fragmentType": "Main_data";
};
export type Main_data$key = {
  readonly " $data"?: Main_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"Main_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Main_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AuthGuard_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CurrentUserProvider_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MainToolbar_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "07e381d03571a12f37e2535b231f573f";

export default node;
